import { Component, OnInit, Input } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ClubActions, ClubSelectors } from '@serviceos-ng/core';

@Component({
    selector: 'serviceos-web-benefits',
    templateUrl: './benefits.component.html',
    styleUrls: ['./benefits.component.scss'],
})
export class BenefitsComponent implements OnInit {
    @Select(ClubSelectors.getBenefits)
    benefitsConfig$!: Observable<any>;

    @Input()
    texts = {
        expand: 'expand',
        expanded: 'expanded'
    }

    public expanded = false;

    constructor(private store: Store) {}

    ngOnInit(): void {
        this.store.dispatch(new ClubActions.FetchBenefits());
    }
}
